__turbopack_context__.v({
  "className": "caveat_d31371ec-module__fTPsiq__className",
});
